export const ZIndex = {
    appShell: 10000,
    modal: 10001,
    dropdown: 1001,
    base: 1000
};
